import { createSelector } from '@reduxjs/toolkit';

import { selectImprovementsEntities } from './propertyDataSelectors/improvementsSelectors.ts';

export const selectSubjectPropertyType = createSelector(
  [selectImprovementsEntities],
  (improvements) => improvements.subject?.propertyType,
);
